// An owned footer is a referral channel. Artist names are never a medium.
export function normalizeOwnedReferral(input) {
  const value = { ...input };
  if (['gclid', 'gbraid', 'wbraid'].some(key => value[key])
      || /^(cpc|ppc|paid|paid_search|paid_social)$/i.test(value.utm_medium || '')) return value;
  const source = (value.utm_source || '').toLowerCase().replace(/\/+$/, '');
  const sources = {
    gateway: ['indfy.me', 'smartlink_footer'],
    'indfy.me': ['indfy.me', 'smartlink_footer'],
    indiefy_me: ['indiefy.me', 'artist_page'],
    'indiefy-me': ['indiefy.me', 'artist_page'],
    'indiefy.me': ['indiefy.me', 'artist_page'],
    'indiefy-smartlink-footer': ['smartlinks.indiefy.net', 'smartlink_generator'],
  };
  if (sources[source]) {
    value.utm_source = sources[source][0];
    value.utm_medium = 'referral';
    value.utm_campaign = sources[source][1];
  }
  return value;
}
